// OnboardingLayout.jsx — only the Header import/usage changes
import OnboardingHeader from '../Footer/OnboardingHeader'; // adjust path to wherever you save OnboardingHeader.jsx
import Footer from '../Footer/Footer';

const OnboardingLayout = ({ children }) => {
  return (
    <>
      <OnboardingHeader />
      <main>{children}</main>
      <Footer />
    </>
  );
};
export default OnboardingLayout;